exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-f321acb6]{padding:.28rem .3rem}.search-bar[data-v-f321acb6]{height:.6rem;line-height:.6rem;font-size:.28rem;background:#f4f4f7;border-radius:.3rem;padding-left:.4rem}.search-bar input[data-v-f321acb6]{margin-left:.16rem;background:#f4f4f7}.active[data-v-f321acb6]{color:#0047ba}.filtrate-class[data-v-f321acb6]{padding:0 .2rem}.filtrate-list[data-v-f321acb6]{padding:.2rem 0}.filtrate-list[data-v-f321acb6]:after{content:\"\";display:block;clear:both}.filtrate-item[data-v-f321acb6]{background:#f2f2f7;border-radius:.04rem;float:left;color:#3d3d3d;padding:0 .16rem;text-align:center;height:.56rem;line-height:.56rem;margin-right:.1rem}.fr[data-v-f321acb6]{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f321acb6","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/search/search.vue
// module id = 364
// module chunks = 0